/*
  The Bridge: on-page buy block (snippets/bw-buy.liquid)
  Turns the option pickers into a variant id for the theme's <product-form>.
  - Colour and adapter choices start selected; size starts empty so nobody orders the wrong size.
  - Options with no available variant (given the other choices) are marked sold out.
  - Price, image and button text follow the chosen variant.
*/
(function () {
  'use strict';
  if (customElements.get('bw-buy')) return;

  class BwBuy extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.variants = JSON.parse(this.querySelector('[data-bw-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }
      this.sizeIndex = parseInt(this.dataset.sizeIndex, 10);
      this.idInput = this.querySelector('[data-bw-id]');
      this.button = this.querySelector('[data-bw-button]');
      this.buttonText = this.querySelector('[data-bw-button-text]');
      this.priceEl = this.querySelector('[data-bw-price]');
      this.compareEl = this.querySelector('[data-bw-compare]');
      this.image = this.querySelector('[data-bw-image]');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-index]')) this.update();
      });
      this.update();
    }

    selected() {
      const count = this.variants.length ? this.variants[0].options.length : 0;
      const picks = new Array(count).fill('');
      this.querySelectorAll('[data-option-index]').forEach((el) => {
        const i = parseInt(el.dataset.optionIndex, 10);
        if (el.tagName === 'SELECT') picks[i] = el.value;
        else if (el.checked) picks[i] = el.value;
      });
      return picks;
    }

    matches(variant, picks, skip) {
      return picks.every((p, i) => i === skip || p === '' || variant.options[i] === p);
    }

    update() {
      const picks = this.selected();

      // Mark each value sold out when no available variant has it alongside the other picks
      this.querySelectorAll('[data-option-index]').forEach((el) => {
        const i = parseInt(el.dataset.optionIndex, 10);
        const values = el.tagName === 'SELECT' ? Array.from(el.options).filter((o) => o.value) : [el];
        values.forEach((node) => {
          const ok = this.variants.some((v) => v.available && v.options[i] === node.value && this.matches(v, picks, i));
          if (el.tagName === 'SELECT') {
            node.textContent = node.value + (ok ? '' : ' · sold out');
            node.disabled = !ok;
          } else {
            const label = this.querySelector('label[for="' + el.id + '"]');
            if (label) label.classList.toggle('is-sold-out', !ok);
          }
        });
      });

      // Show the chosen value next to each option name
      this.querySelectorAll('fieldset').forEach((fs) => {
        const checked = fs.querySelector('input:checked');
        const out = fs.querySelector('[data-bw-value]');
        if (checked && out) out.textContent = checked.value.replace(/\s*\(\s*with\s+/i, ' · ').replace(/\)\s*$/, '').trim();
      });

      const complete = picks.every((p) => p !== '');
      const variant = complete ? this.variants.find((v) => v.options.every((o, i) => o === picks[i])) : null;
      // For price and image before a size is chosen, use any variant matching the picks so far
      const preview = variant || this.variants.find((v) => this.matches(v, picks, -1)) || this.variants[0];

      if (preview) {
        this.priceEl.textContent = preview.price;
        this.compareEl.textContent = preview.compare || '';
        if (this.image && preview.image && this.image.getAttribute('src') !== preview.image) {
          this.image.removeAttribute('srcset');
          this.image.setAttribute('src', preview.image);
        }
      }

      let text;
      let enabled = false;
      if (!complete) {
        text = picks[this.sizeIndex] === '' ? 'Select your size' : 'Choose your options';
      } else if (!variant || !variant.available) {
        text = 'Sold out in this size';
      } else {
        text = 'Add to bag · ' + variant.price;
        enabled = true;
      }
      this.idInput.value = variant ? variant.id : '';
      this.buttonText.textContent = text;
      if (enabled) this.button.removeAttribute('aria-disabled');
      else this.button.setAttribute('aria-disabled', 'true');
      this.button.classList.toggle('is-ready', enabled);
    }
  }

  customElements.define('bw-buy', BwBuy);
})();
